import React, { useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import moment from "moment";
import {
  CommonStyle,
  CommonHeaderStyle,
  displayNullFormatter,
} from "../Utility/utilis";
import { useDispatch, useSelector } from "react-redux";
import NoData from "../Utility/NoData";
import { setSchedulerTableData } from "./action";

const columns = [
  {
    dataField: "Entity",
    text: "Entity",
    style: (cell, row, rowIndex, colIndex) => CommonStyle(),
    headerStyle: CommonHeaderStyle,
    formatter: (cell, row) => displayNullFormatter(row, "ENTITY"),
  },
  {
    dataField: "GSTIN",
    text: "GSTIN",
    style: (cell, row, rowIndex, colIndex) => CommonStyle(),
    headerStyle: CommonHeaderStyle,
    formatter: (cell, row) => displayNullFormatter(row, "GSTIN"),
  },
  {
    dataField: "START_DATE",
    text: "Start Date",
    style: (cell, row, rowIndex, colIndex) => CommonStyle(),
    headerStyle: CommonHeaderStyle,
    formatter: (cell, row) => row.START_DATE ? moment(row.START_DATE).format("DD-MM-YYYY") : "-",
  },
  {
    dataField: "END_DATE",
    text: "End Date",
    style: (cell, row, rowIndex, colIndex) => CommonStyle(),
    headerStyle: CommonHeaderStyle,
    formatter: (cell, row) => row.END_DATE ? moment(row.END_DATE).format("DD-MM-YYYY") : "-",
  },
  {
    dataField: "FREQ_CODE",
    text: "Frequency",
    style: (cell, row, rowIndex, colIndex) => CommonStyle(),
    headerStyle: CommonHeaderStyle,
    formatter: (cell, row) => displayNullFormatter(row, "FREQ_CODE"),
  },
  {
    dataField: "RUN_TIME_LOCAL",
    text: "Time",
    style: (cell, row, rowIndex, colIndex) => CommonStyle(),
    headerStyle: CommonHeaderStyle,
    formatter: (cell, row) => displayNullFormatter(row, "RUN_TIME_LOCAL"),
  },
  // {
  //   dataField: "status",
  //   text: "Status",
  //   style: (cell, row, rowIndex, colIndex) => CommonStyle(),
  //   headerStyle: CommonHeaderStyle,
  //   formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  // },
];

export default function SchedularTable() {
  const dispatch = useDispatch();
  const { schedulerTableData } = useSelector((state) => state.noticeReducer);

  useEffect(() => {
    return () => dispatch(setSchedulerTableData([]));
  }, []);
  return (
    <>
      {schedulerTableData && schedulerTableData.length > 0 ? (
        <div className="light-border-notice-table">
          <BootstrapTable
            keyField="scheduleId"
            data={schedulerTableData}
            columns={columns}
          />
        </div>
      ) : (
        <NoData />
      )}
    </>
  );
}
